// extracted by mini-css-extract-plugin
module.exports = {"label":"OrgCardInput_label__3d1iZ","input":"OrgCardInput_input__2YUv9","error":"OrgCardInput_error__3Vy6D"};